import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  successMessage: undefined,
  errorMessage: undefined,
};

const drmCoupaUpdateSlice = createSlice({
  name: "drmCoupaUpdate",
  initialState,
  reducers: {
    updateCoupaFilesStart: (state) => {
      state.isLoading = true;
      state.successMessage = undefined;
      state.errorMessage = undefined;
    },
    updateCoupaFilesSuccess: (state, action) => {
      state.isLoading = false;
      state.successMessage = action.payload;
    },
    updateCoupaFilesFailure: (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload;
    },
    resetUpdateCoupaFilesState: () => ({ ...initialState }),
  },
});

export const {
  updateCoupaFilesStart,
  updateCoupaFilesSuccess,
  updateCoupaFilesFailure,
  resetUpdateCoupaFilesState,
} = drmCoupaUpdateSlice.actions;

export default drmCoupaUpdateSlice.reducer;
